import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { clsx as cx } from 'clsx';
import * as React from 'react';
import { findNotDisabledElement } from '../utils/findNotDisabledElement';
import { getDeviceStyles } from '../../styles/scrollTrack/getDeviceStyles';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType';
import { ScrollButton } from '../ScrollButton/ScrollButton';
var ARROW_WIDTH = 48;
export var ScrollTrack = function ScrollTrack(_ref) {
  var children = _ref.children,
    setFocusVisible = _ref.setFocusVisible,
    activeTab = _ref.activeTab;
  var tabsListRef = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    needRightArrow = _React$useState2[0],
    setNeedRightArrow = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    needLeftArrow = _React$useState4[0],
    setNeedLeftArrow = _React$useState4[1];
  var deviceType = useDeviceType();
  var styles = getDeviceStyles(deviceType);
  var handleScroll = function handleScroll(_ref2) {
    var direction = _ref2.direction;
    var tabsList = tabsListRef.current;
    if (!tabsList) {
      return;
    }
    tabsList.scrollLeft = tabsList.scrollLeft + direction * tabsList.offsetWidth;
  };
  var scrollLeft = function scrollLeft() {
    return handleScroll({
      direction: -1
    });
  };
  var scrollRight = function scrollRight() {
    return handleScroll({
      direction: 1
    });
  };
  var checkArrowsVisibility = function checkArrowsVisibility() {
    var tabsList = tabsListRef.current;
    if (!tabsList) {
      return;
    }
    var tabsListWidth = tabsList.scrollWidth;
    var containerWidth = tabsList.offsetWidth;
    var containerScrollLeft = tabsList.scrollLeft;

    // Показываем правую стрелку если табы не помещаются в ширину и не проскроленно до конца
    var needRightArrow = tabsListWidth > containerWidth && containerWidth + containerScrollLeft < tabsListWidth;
    var needLeftArrow = containerScrollLeft > 0;
    setNeedRightArrow(needRightArrow);
    setNeedLeftArrow(needLeftArrow);
  };
  var onScroll = function onScroll() {
    return checkArrowsVisibility();
  };
  var handleKeyDown = function handleKeyDown(event) {
    var target = event.target;
    var tabsList = tabsListRef.current;
    var role = target.getAttribute('role');
    if (role !== 'tab' || !tabsList) {
      return;
    }
    var newFocusTarget = null;
    setFocusVisible(true);
    switch (event.key) {
      case 'ArrowLeft':
        newFocusTarget = findNotDisabledElement({
          target: target,
          reverse: true
        }) || findNotDisabledElement({
          target: tabsList.lastChild,
          reverse: true,
          startWithTarget: true
        });
        break;
      case 'ArrowRight':
        newFocusTarget = findNotDisabledElement({
          target: target
        }) || findNotDisabledElement({
          target: tabsList.firstChild,
          reverse: false,
          startWithTarget: true
        });
        break;
      default:
        break;
    }
    if (newFocusTarget !== null) {
      newFocusTarget.focus();
      event.preventDefault();
    }
  };
  React.useEffect(function () {
    var scrollToActiveTab = function scrollToActiveTab() {
      if (tabsListRef.current) {
        var childen = tabsListRef.current.childNodes;
        var activeChildenIndex = Object.keys(childen).find(function (index) {
          return childen[Number(index)].getAttribute('aria-selected') === 'true';
        });
        if (childen[Number(activeChildenIndex)]) {
          var trackScrollLeft = tabsListRef.current.scrollLeft;
          var trackWidth = tabsListRef.current.clientWidth;
          var itemOffsetLeft = childen[Number(activeChildenIndex)].offsetLeft;
          var itemWidth = childen[Number(activeChildenIndex)].clientWidth;
          if (itemOffsetLeft < trackScrollLeft + ARROW_WIDTH) {
            tabsListRef.current.scrollLeft = itemOffsetLeft - ARROW_WIDTH;
          }
          if (itemOffsetLeft + itemWidth >= trackScrollLeft + trackWidth - ARROW_WIDTH) {
            tabsListRef.current.scrollLeft = itemOffsetLeft - trackWidth + itemWidth + ARROW_WIDTH;
          }
        }
      }
    };
    checkArrowsVisibility();
    scrollToActiveTab();
  }, [deviceType, activeTab]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles['wrap'], needLeftArrow && styles['wrap-left-blur'], needRightArrow && styles['wrap-right-blur'])
  }, needLeftArrow && /*#__PURE__*/React.createElement(ScrollButton, {
    onClick: scrollLeft
  }), /*#__PURE__*/React.createElement("div", {
    role: "tablist",
    ref: tabsListRef,
    onScroll: onScroll,
    className: cx(styles['tabs']),
    onKeyDown: handleKeyDown
  }, children), needRightArrow && /*#__PURE__*/React.createElement(ScrollButton, {
    onClick: scrollRight,
    right: true
  }));
};